import { combineEpics } from 'redux-observable';

import { listEarningsEpic } from './list-earnings';
// import { listUserEarningsEpic } from './list-user-earnings';
import { getTotalEarningsEpic } from './get-total-earnings';
import { listDeactivatedArtistEarningsEpic } from './list-deactivated-artist-earnings';
import { earningsGenerateExportUrlEpic } from './generate-export-url';
import { getEarningsExportUrlEpic } from './get-export-url';
import { successEarningsExportUrlEpic } from './success-generate-export-url';
import { successGetEarningsExportUrlEpic } from './success-get-export-url';
import { resetArtistEarningsEpic } from './reset-artist-earnings';

const earningsEpic = combineEpics(
  listEarningsEpic,
  getTotalEarningsEpic,
  // listUserEarningsEpic,
  listDeactivatedArtistEarningsEpic,
  earningsGenerateExportUrlEpic,
  getEarningsExportUrlEpic,
  successEarningsExportUrlEpic,
  successGetEarningsExportUrlEpic,
  resetArtistEarningsEpic
);

export default earningsEpic;
